import { render, staticRenderFns } from "./PatientError.vue?vue&type=template&id=5e998e56&scoped=true&"
import script from "./PatientError.vue?vue&type=script&lang=js&"
export * from "./PatientError.vue?vue&type=script&lang=js&"
import style0 from "./PatientError.vue?vue&type=style&index=0&id=5e998e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e998e56",
  null
  
)

export default component.exports